export const ONE_TIME = 'One-time'
export const MONTHLY = 'Monthly'